import React, { useState } from 'react';
import puter from '@heyputer/puter.js';
import '../css/JSPlayer.css';

export function Imagebot() {
    const [query, setQuery] = useState('');
    const [reply, setReply] = useState('');
    const [loading, setLoading] = useState('');

    function onBtnRunClick(e) {
        e.preventDefault();
        //alert("Imagebot is under development");
        setLoading('loading');
        puter.ai.txt2img(query)
            .then(imageElement => {
                setLoading('');
                setReply(imageElement);
            });
        return false;
    }

    function handleChange(e) {
        setQuery(e.target.value);
    }

    return (
        <>
            <div className={`container mt-3 ${loading}`}>
                <h1>What do you want me to draw?</h1>
                <form>
                    <div className="mb-3">
                        <textarea className="form-control" rows="3" cols="500" id="query" aria-describedby="query-input" required
                            value={query} onChange={handleChange}>
                        </textarea>
                    </div>
                    <button className="btn btn-primary mb-3" onClick={onBtnRunClick}>Submit</button>
                </form>
                <div>
                    <label htmlFor="message" className="form-label">Response</label>
                    <div className="card">
                        <div className="card-body" style={{ minHeight: '20em' }}><img alt="Drawing with love" src={reply} /></div>
                    </div>
                </div>
                {loading && <div class='overlay'></div>}
            </div>
        </>
    );
}